import { render } from "./Dashboard.vue?vue&type=template&id=7bf9cd94&scoped=true&ts=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=7bf9cd94&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=7bf9cd94&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf9cd94"]])

export default __exports__